import type { CartItem } from '../types';
import type { AppliedCoupon } from '../types/coupon';
import { formatAmount } from '../utils/formatPrice';
import { calculateOrderTotals } from '../utils/checkout';
import { getUnitPrice } from '../utils/product';

type PreInformationSummaryProps = {
  items: CartItem[];
  subtotal: number;
  appliedCoupon?: AppliedCoupon | null;
};

export default function PreInformationSummary({
  items,
  subtotal,
  appliedCoupon = null,
}: PreInformationSummaryProps) {
  const { discountAmount, shipping, total } = calculateOrderTotals(subtotal, appliedCoupon);

  return (
    <div className="pre-info-summary">
      <h3>Ön Bilgilendirme Özeti</h3>

      <div className="pre-info-block">
        <h4>Satıcı Bilgileri</h4>
        <p>BALIKESİR GÜVEN ÖZEL SAĞLIK LABORATUVAR HİZMETLERİ LTD. ŞTİ.</p>
        <p>Bahçelievler Mah. Atatürk Cad. Erdem Sitesi No: 10 B Altıeylül / Balıkesir</p>
        <p>Telefon: +90 553 538 24 62</p>
        <p>E-posta: guvenozelsaglik@gmail.com</p>
      </div>

      <div className="pre-info-block">
        <h4>Sözleşme Konusu Ürünler</h4>
        <ul>
          {items.map(({ product, quantity }) => (
            <li key={product.id}>
              {product.name} — {quantity} adet —{' '}
              {formatAmount(getUnitPrice(product) * quantity, product.currency)}
            </li>
          ))}
        </ul>
      </div>

      <div className="pre-info-block">
        <h4>Fiyat ve Ödeme</h4>
        <p>Ara toplam: {formatAmount(subtotal)}</p>
        {discountAmount > 0 && (
          <p>
            İndirim{appliedCoupon ? ` (${appliedCoupon.code})` : ''}: −
            {formatAmount(discountAmount)}
          </p>
        )}
        <p>Kargo: {shipping === 0 ? 'Ücretsiz' : formatAmount(shipping)}</p>
        <p>
          <strong>Toplam (vergiler dahil): {formatAmount(total)}</strong>
        </p>
        <p>Ödeme yöntemi: Kredi/bank kartı (İyzico altyapısı)</p>
      </div>

      <div className="pre-info-block">
        <h4>Teslimat</h4>
        <p>
          Ürünler, sipariş sırasında belirttiğiniz teslimat adresine kargo firması aracılığıyla
          gönderilir. Teslimat süresi stok ve lojistik koşullara göre değişebilir.
        </p>
      </div>

      <div className="pre-info-block">
        <h4>Cayma Hakkı</h4>
        <p>
          Tüketici, ürünü teslim aldığı tarihten itibaren 14 gün içinde herhangi bir gerekçe
          göstermeksizin cayma hakkını kullanabilir. Hijyen ve mevzuat kapsamındaki istisnalar
          saklıdır.
        </p>
      </div>
    </div>
  );
}
